var MASK_CHAR = "●",
    BACKEND_MASK_CHAR = "X",
    SSN_MASK = MASK_CHAR + MASK_CHAR + MASK_CHAR + "-" + MASK_CHAR + MASK_CHAR + "-", // Masks first 5 digits of SSN
    TIN_MASK = MASK_CHAR + MASK_CHAR + "-" + MASK_CHAR + MASK_CHAR + MASK_CHAR, // Masks first 5 digits of TIN
    DOB_MASK = MASK_CHAR + MASK_CHAR + "/" + MASK_CHAR + MASK_CHAR + "/", // Masks month and day of DOB
    MASKED_DATE_FORMAT = "[" + MASK_CHAR + MASK_CHAR + "]/[" + MASK_CHAR + MASK_CHAR + "]/YYYY"; // Format for dayjs

/**
 * Check if the value is masked.
 *
 * @param  {String}  value The value to check
 * @return {Boolean}       True if the value is masked; false otherwise
 */
function isMasked(value) {
    if (value && value.indexOf(MASK_CHAR) !== -1) {
        return true;
    }

    return false;
}

/**
 * Mask the Social Security Number (SSN).
 *
 * @param  {String} ssn The Social Security Number to mask
 * @return {String}     The masked Social Security Number
 */
function maskSSN(ssn) {
    return ssn.replace(/^\d{3}-?\d{2}-?/, SSN_MASK);
}

/**
 * Mask theTax Identification Number (TIN).
 *
 * @param  {String} ssn TheTax Identification Number to mask
 * @return {String}     The maskedTax Identification Number
 */
function maskTIN(ssn) {
    return ssn.replace(/^\d{2}-?\d{3}?/, TIN_MASK);
}
/**
 * Mask the Date of Birth (DOB).
 *
 * @param  {String} dateOfBirth The Date of Birth to mask
 * @return {String}             The masked Date of Birth
 */
function maskDOB(dateOfBirth) {
    return dateOfBirth.replace(/^\d{2}\/\d{2}\//, DOB_MASK);
}

/**
 * Convert the UI masked value to the backend mask format (as of 11/3/2017 the backend still masks with 'X').
 *
 * @param  {String} value        The masked value to convert
 * @param  {String} defaultValue The default value to return if the input is invalid
 * @return {String}              The value masked in the backend masking format
 */
function convertToBackendMask(value, defaultValue) {
    if (typeof value === "string") {
        return value.replace(new RegExp(MASK_CHAR, "g"), BACKEND_MASK_CHAR);
    }

    return defaultValue;
}

/**
 * Convert the backend masked value to the UI mask format (as of 11/3/2017 the backend still masks with 'X').
 *
 * @param  {String} value        The masked value to convert
 * @param  {String} defaultValue The default value to return if the input is invalid
 * @return {String}              The value masked in the UI masking format
 */
function convertFromBackendMask(value, defaultValue) {
    if (typeof value === "string") {
        return value.replace(new RegExp(BACKEND_MASK_CHAR, "g"), MASK_CHAR);
    }

    return defaultValue;
}

const MaskUtil = {
    MASK_CHAR: MASK_CHAR,
    MASKED_DATE_FORMAT: MASKED_DATE_FORMAT,
    isMasked: isMasked,
    maskSSN: maskSSN,
    maskTIN: maskTIN,
    maskDOB: maskDOB,
    convertToBackendMask: convertToBackendMask,
    convertFromBackendMask: convertFromBackendMask
};
export default MaskUtil;
